import { type DestinationGoogleData } from "types/quote-types";

export function getGooglePlacesDestinationNameForDisplay(
  destination: DestinationGoogleData,
) {
  if (destination.terms?.length) {
    return destination.terms[0].value;
  } else if (destination?.address_components?.length) {
    for (const component of destination.address_components) {
      if (
        component.types.includes("locality") ||
        component.types.includes("administrative_area_level_1") ||
        component.types.includes("country")
      ) {
        return component.long_name;
      }
    }
  }

  return "";
}
